import { useMutation } from 'react-query';
import { validateEmail, validatePhoneNumber } from 'services/validations';

export const useAsyncValidateEmail = () => {
  return useMutation(
    async (email) => {
      if (!email) {
        throw new Error('The email is empty');
      }
      return await validateEmail({ email });
    },
    {
      onSuccess: (response) => {
        return response;
      },
      onError: (error) => {
        return error;
      },
    },
  );
};

export const useAsyncValidatePhone = () => {
  return useMutation(
    async (phoneNumber) => {
      if (!phoneNumber) {
        throw new Error('The Phone number is empty');
      }
      return await validatePhoneNumber({ phoneNumber });
    },
    {
      onSuccess: (response) => {
        return response;
      },
      onError: (error) => {
        return error;
      },
    },
  );
};
